<template>
  <div
    class="pt-0 mx-10"
    style="border:1px solid black"
  >
    <v-tabs
      ref="tabs"
      v-model="active"
      align-with-title
      slider-color="white"
      show-arrows
    >
      <v-tab
        v-for="item in filteredTabItems"
        :key="item.name"
        class="divider font-black"
      >
        {{ item.name }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="active">
      <!-- General Info-->
      <v-tab-item class="pb-12">
        <employee-profile-general-info-personal-detail-container-view
          ref="personal"
          :employee-uid="employeeUid"
          class="py-3"
          :is-resigned="isResigned"
          @updated="refreshStatutoryDetails"
        />

        <employee-profile-general-info-working-experience-container-view
          v-if="isMyProfile || $hasPermissionTo(['view working experiences'])"
          class="pb-2"
          :employee-uid="employeeUid"
          :is-resigned="isResigned"
        />

        <employee-profile-general-info-education-background-container-view
          v-if="isMyProfile || $hasPermissionTo(['view education backgrounds'])"
          class="pb-2"
          :employee-uid="employeeUid"
          :is-resigned="isResigned"
        />

        <employee-profile-general-info-dependent-container-view
          v-if="isMyProfile || $hasPermissionTo(['view dependents'])"
          class="pb-2"
          :employee-uid="employeeUid"
          :employee-marital-status="(((employee || {}).person || {}).lookup || {}).value"
          :is-resigned="isResigned"
          @refresh="refreshPersonalDetails"
        />

        <employee-profile-general-info-beneficiary-container-view
          v-if="isMyProfile || $hasPermissionTo(['view beneficiaries'])"
          class="pb-2"
          :employee-uid="employeeUid"
          :is-resigned="isResigned"
        />

        <employee-profile-general-info-emergency-contact-container-view
          v-if="isMyProfile || $hasPermissionTo(['view emergency contacts'])"
          class="pb-2"
          :employee-uid="employeeUid"
          :is-resigned="isResigned"
        />
      </v-tab-item>

      <!-- Job-->
      <v-tab-item class="pb-12">
        <employee-profile-job-container-view
          :employee-uid="employeeUid"
          class="py-3"
          :is-resigned="isResigned"
          @updated="$emit('updated'); refreshEmployeeMovementDetails(); refreshPayrollDetails()"
        />
      </v-tab-item>

      <!-- Payroll -->
      <v-tab-item
        v-if="!isMyProfile && $hasPermissionTo(['view employee payroll'])" 
        class="pb-12"
      >
        <employee-profile-payroll-container-view
          ref="payroll"
          :employee-uid="employeeUid" 
          :is-resigned="isResigned"
          @updated="refreshEmployeeMovementDetails()"
          @loaded="setPayrollLoaded"
        />
      </v-tab-item>

      <!-- Payroll Company (e-Invoice) -->
      <v-tab-item
        v-if="isMyProfile"
        class="pb-12"
      >
        <employee-profile-company-container-view :employee-uid="employeeUid" />
      </v-tab-item>

      <!-- Disciplines -->
      <v-tab-item
        v-if="isMyProfile || $hasPermissionTo(['view employee disciplines'])"
        class="pb-12"
      >
        <employee-profile-discipline-container-view :employee-uid="employeeUid" />
      </v-tab-item>

      <!-- Movements -->
      <v-tab-item
        v-if="!isMyProfile && $hasPermissionTo(['view employee movements'])"
        class="pb-12"
      >
        <employee-profile-movement-container-view
          ref="movement"
          :employee-uid="employeeUid"
          @loaded="setMovementLoaded"
        />
      </v-tab-item>

      <!-- Others-->
      <v-tab-item class="pb-12">
        <v-row no-gutters>
          <v-col cols="6">
            <employee-profile-vaccination-container-view
              v-if="$hasPermissionTo(['view employee vaccinations']) || isMyProfile"
              :employee-uid="employeeUid"
            />
          </v-col>
        </v-row>
      </v-tab-item>

      <!-- Settings -->
      <v-tab-item
        v-if="!isMyProfile"
        class="pb-12"
      >
        <employee-profile-setting-role-container-view
          :user-uid="userUid"
          type="hris"
        />
        
        <v-divider />

        <employee-profile-setting-approve-on-behalf-scope-container-view
          :employee-uid="employeeUid"
        />

        <v-divider />

        <employee-profile-setting-system-access-container-view :user-uid="userUid" />

        <v-divider />   

        <employee-profile-setting-notification-container-view :employee-uid="employeeUid" />

        <v-divider />      

        <!-- <employee-profile-setting-attendance-container-view
          v-if="$hasPermissionTo(['attendance setting view'])"
          :employee-uid="employeeUid"
        /> -->
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    components: {
      EmployeeProfileGeneralInfoWorkingExperienceContainerView: () => import('@/components/hris/employee/profile/general-info/working-experience/ContainerView'),
      EmployeeProfileGeneralInfoEmergencyContactContainerView: () => import('@/components/hris/employee/profile/general-info/emergency-contact/ContainerView'),
      EmployeeProfileGeneralInfoBeneficiaryContainerView: () => import('@/components/hris/employee/profile/general-info/beneficiary/ContainerView'),
      EmployeeProfileGeneralInfoEducationBackgroundContainerView: () => import('@/components/hris/employee/profile/general-info/education-background/ContainerView'),
      EmployeeProfileGeneralInfoDependentContainerView: () => import('@/components/hris/employee/profile/general-info/dependent/ContainerView'),
      EmployeeProfileGeneralInfoPersonalDetailContainerView: () => import('@/components/hris/employee/profile/general-info/personal-detail/ContainerView'),
      EmployeeProfileJobContainerView: () => import('@/components/hris/employee/profile/job/ContainerView'),
      EmployeeProfilePayrollContainerView: () => import('@/components/hris/employee/profile/payroll/ContainerView'),
      EmployeeProfileSettingRoleContainerView: () => import('@/components/hris/employee/profile/setting/role/ContainerView'),
      EmployeeProfileSettingNotificationContainerView: () => import('@/components/hris/employee/profile/setting/notification/ContainerView'),
      EmployeeProfileSettingSystemAccessContainerView: () => import('@/components/hris/employee/profile/setting/system-access/ContainerView'),
      EmployeeProfileSettingApproveOnBehalfScopeContainerView: () => import('@/components/hris/employee/profile/setting/approve-on-behalf-scope/ContainerView'),
      EmployeeProfileMovementContainerView: () => import('@/components/hris/employee/profile/movement/ContainerView'),
      EmployeeProfileVaccinationContainerView: () => import('@/components/hris/employee/profile/vaccination/ContainerView'),
      EmployeeProfileDisciplineContainerView: () => import('@/components/hris/employee/profile/discipline/ContainerView'),
      EmployeeProfileCompanyContainerView: () => import('@/components/hris/employee/profile/company/ContainerView'),
    },
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
      userUid: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        tabItems: [
          { name: 'General Info' },
          { name: 'Job' },
          { name: 'Payroll' },
          { name: 'Discipline' },
          { name: 'Movement' },
          { name: 'Others' },
          { name: 'Settings' },
        ],
        profileTabItems: [
          { name: 'General Info' },
          { name: 'Job' },
          { name: 'Company' },
          { name: 'Discipline' },
          { name: 'Others' },
        ],
        active: 0,
        isResigned: false,
        movementLoaded: false,
        payrollLoaded: false,
        employee: {},
      }
    },
   
    computed: {  
      ...mapState({ isCurrentUser: 'isMyProfile' }),
 
      filteredTabItems () {
        let originalTab = [...this.profileTabItems]

        if (this.isMyProfile) return originalTab

        let modifiedTab = [...this.tabItems]

        if (!this.$hasPermissionTo(['view employee payroll'])) {
          modifiedTab.splice(
            modifiedTab.findIndex(tab => {
              return tab.name === 'Payroll'
            }) 
            , 1)
        }

        if (!this.$hasPermissionTo(['view employee disciplines'])) {
          modifiedTab.splice(
            modifiedTab.findIndex(tab => {
              return tab.name === 'Discipline'
            }) 
            , 1)
        }

        if (!this.$hasPermissionTo(['view employee movements'])) {
          modifiedTab.splice(
            modifiedTab.findIndex(tab => {
              return tab.name === 'Movement'
            }) 
            , 1)
        }

        if (!this.$hasPermissionTo(['view user roles']) && !this.$hasPermissionTo(['update user settings'])) {
          modifiedTab.splice(
            modifiedTab.findIndex(tab => {
              return tab.name === 'Settings'
            }) 
            , 1)
        }

        return modifiedTab
      },

      isMyProfile () {
        return this.$store.state.isMyProfile
      },

      selectedTab () {
        return this.filteredTabItems[this.active]
      },
    },

    watch: {
      employeeUid: {
        immediate: true,
        handler (value) {
          if (value) {
            this.movementLoaded = false
            this.payrollLoaded = false
            
            this.$api.hrisEmployees().show(this.employeeUid)
              .then(res => {
                this.employee = res.data
                if (res.data.end_date !== null && res.data.end_date <= this.$moment().format('YYYY-MM-DD')) {
                  this.isResigned = true
                } else {
                  this.isResigned = false
                }
              })
          }
        },
      },
    },

    methods: {
      refreshPersonalDetails () {
        this.$refs.personal.loadPersonalDetails()
      },   
      refreshEmployeeMovementDetails () {
        if (this.movementLoaded && this.$hasPermissionTo(['view employee movements'])) {
          this.$refs.movement.loadEmployeeMovements()
        }
      },
      refreshPayrollDetails () {
        if (this.payrollLoaded && this.$hasPermissionTo(['view employee payroll'])) {
          this.$refs.payroll.loadPayrolls()
        }
      },
      refreshStatutoryDetails () {
        // SOCSO number follows IC number and citizenship, payroll tab only exists once visited
        if (this.$refs.payroll) {
          this.$refs.payroll.loadStatutoryDetails()
        }
      },
      setMovementLoaded () {
        this.movementLoaded = true
      },
      setPayrollLoaded () {
        this.payrollLoaded = true
      },
    },
  }
</script>

<style scoped>
.divider {
  border-right: 1px solid #707070;
  border-bottom: 1px solid #707070;
}

.font-black {
  color: black !important;
}

.divider.font-black.v-tab.v-tab--active {
  border-bottom: 0px;
}

.v-tab {
  text-transform: none !important;
  max-height: 33px;
}
</style>
